import React from "react";
import { FTypo } from "ferrum-design-system";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/rootReducer";

const CrucibleDashboardCards = ({ item, tokenData }: any) => {
  const { theme } = useSelector((state: RootState) => state.config);

  const GlobalStyle = createGlobalStyle`
    .crucible-dashboard-card {
      background-image: url(${theme?.cards?.crucibleLandingMiniCard}) !important;
    }
  `;

  return (
    <ThemeProvider theme={theme}>
      <div className={"crucible-dashboard-card"}>
        <div className={"justify-content-center align_center f-mb-1"}>
          <span className="icon-network">
            <img
              src={tokenData[item.name]?.logo}
              height="30px"
              width="26px"
              style={{ marginRight: 3 }}
              alt=""
            />
          </span>
          <FTypo size={18} weight={700} color={theme?.colors?.primaryLight}>
            {item.network}
          </FTypo>
        </div>
        <FTypo
          size={12}
          weight={500}
          color={theme?.colors?.backgroundLight}
          className={"f-mb--2"}
        >
          Price
        </FTypo>
        <FTypo size={22} weight={600} color={theme?.colors?.primaryLight}>
          {item.price}
        </FTypo>
        <div className={"justify-content-space-between align_center f-mt-1"}>
          <div>
            <FTypo size={16} weight={600} color={theme?.colors?.primaryLight}>
              {item.cNetworkPrice}
            </FTypo>
            <FTypo size={12} weight={500} color={theme?.colors?.primary}>
              {item.cNetwork} Price
            </FTypo>
          </div>
          <div>
            <FTypo size={16} weight={600} color={theme?.colors?.primaryLight}>
              {item.cruciblePrice}
            </FTypo>
            <FTypo size={12} weight={500} color={theme?.colors?.primary}>
              {item.network} : {item.cNetwork}
            </FTypo>
          </div>
        </div>
      </div>
      <GlobalStyle />
    </ThemeProvider>
  );
};
export default CrucibleDashboardCards;
